<template>
    <div class="planbord-right-index">
        <slot></slot>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class PlanbordGridRightDataColumns extends Vue {
    }
</script>

<style lang="scss" scoped>
    .planbord-right-index {
        display: grid;
        grid-column: calc(-1 * var(--right-non-day-columns) - 1) / span var(--right-non-day-columns);
        grid-template-columns: subgrid;
        position: sticky;
        right: 0;
        z-index: 98;
        background: var(--main-background-color);
    }
</style>
